import { useQuery } from '@tanstack/react-query'
import { puzzlesAPI } from '../services/api'
import type { Level } from '../../shared/types'

export function usePuzzles() {
  return useQuery<Level[]>({
    queryKey: ['puzzles'],
    queryFn: puzzlesAPI.getAll,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours (puzzles don't change often)
    gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days cache
  })
}

export function usePuzzle(id: string) {
  const { data: puzzles } = usePuzzles()

  return {
    data: puzzles?.find((p) => p.id === id),
    isLoading: !puzzles,
  }
}
